<template>
  <div class="customer-status-filters d-flex i-gap-sm">
    <button
      v-for="(filter, index) in filterItems"
      :key="filter.icon + index"
      :class="{ active: filter.value === params.status }"
      @click="onSelectionChanged(filter.value)"
    >
      <i-icon
        :symbol="filter.icon"
        :size="16"
        :colour="palette['light-neutral-90']"
      />
      <span class="i-text-family i-text-subheading-2">{{ filter.label }}</span>
    </button>
  </div>
</template>

<script>
import { iIcon } from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';

export default {
  components: {
    iIcon,
  },
  data() {
    return {
      palette,
      filterItems: [
        {
          label: 'All Customers',
          value: undefined,
          icon: 'medium-user-multiple',
        },
        {
          label: 'Unresolved',
          value: 'unknown',
          icon: 'small-user-unresolved',
        },
        {
          label: 'Rejected',
          value: 'rejected',
          icon: 'small-user-reject',
        },
        {
          label: 'Approved',
          value: 'approved',
          icon: 'small-user-approve',
        },
      ],
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  methods: {
    onSelectionChanged(filter) {
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          status: filter,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-status-filters {
  button {
    flex: 1 1 0px;
    display: flex;
    column-gap: map-get($increments, 6);
    padding: map-get($increments, 6) map-get($increments, 9);
    border-radius: map-get($increments, 5);
    border: 1px solid $light-neutral-60;
    background-color: $light-neutral-default;
    color: $light-neutral-120;
    align-items: center;

    &:focus,
    &:hover {
      border-color: $light-neutral-80;
    }

    &.active {
      border-color: $light-neutral-90;
      .i-icon {
        color: $light-neutral-110 !important;
      }
    }
  }
}
</style>
